/* src/@fuse/components/progress-bar/progress-bar.component.scss */
:root {
  --mdc-linear-progress-track-height: 2px;
  --mdc-linear-progress-active-indicator-height: 2px;
}
fuse-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99998;
  color: var(--green);
}
fuse-progress-bar mat-progress-bar .mat-progress-bar-buffer {
  background-color: #c5c6cb !important;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL0BmdXNlL2NvbXBvbmVudHMvcHJvZ3Jlc3MtYmFyL3Byb2dyZXNzLWJhci5jb21wb25lbnQuc2NzcyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiQHVzZSAnQGZ1c2Uvc2Nzcy9wYXJ0aWFscy9icmVha3BvaW50cy5zY3NzJyBhcyBicmVha3BvaW50cztcblxuOnJvb3Qge1xuICAgIC0tbWRjLWxpbmVhci1wcm9ncmVzcy10cmFjay1oZWlnaHQ6IDJweDtcbiAgICAtLW1kYy1saW5lYXItcHJvZ3Jlc3MtYWN0aXZlLWluZGljYXRvci1oZWlnaHQ6IDJweDtcbn1cblxuZnVzZS1wcm9ncmVzcy1iYXIge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDA7XG4gICAgbGVmdDogMDtcbiAgICByaWdodDogMDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICB6LWluZGV4OiA5OTk5ODtcbiAgICBjb2xvcjogdmFyKC0tZ3JlZW4pO1xuXG4gICAgbWF0LXByb2dyZXNzLWJhciB7XG4gICAgICAgIC5tYXQtcHJvZ3Jlc3MtYmFyLWJ1ZmZlciB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjYzVjNmNiICFpbXBvcnRhbnQ7XG4gICAgICAgIH1cbiAgICB9XG59XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBRUE7QUFDSSxzQ0FBQTtBQUNBLGlEQUFBOztBQUdKO0FBQ0ksWUFBQTtBQUNBLE9BQUE7QUFDQSxRQUFBO0FBQ0EsU0FBQTtBQUNBLFNBQUE7QUFDQSxXQUFBO0FBQ0EsU0FBQSxJQUFBOztBQUdJLGtCQUFBLGlCQUFBLENBQUE7QUFDSSxvQkFBQTs7IiwKICAibmFtZXMiOiBbXQp9Cg== */
